module.exports = "./img/7f0142588ae110a52a6f67e60cd50196.jpg";